import { Container, ContainerType, Spacer, SpacerVariant, spacerOptionsAll } from "../components/layout"
import Image, { AspectRatio } from "../Image"
import Typography, { TypographyElement } from "../RedesignTypography"

import { Color } from "../components/typography"
import React from "react"
import classNames from "classnames"
import { types } from "react-bricks/frontend"

interface Text4ImagesBlockProps {
    spacerTop?: SpacerVariant
    spacerBottom?: SpacerVariant
    headline: TypographyElement[]
    text: TypographyElement[]
}

const Text4ImagesBlock = ({ spacerTop, spacerBottom }: Text4ImagesBlockProps) => {
    return (
        <Container type={ContainerType.Redesign}>
            <Spacer variant={spacerTop} />
            <div className="grid grid-cols-6 gap-x-1.5 gap-y-10 sm:grid-cols-12 sm:gap-x-3.75 sm:gap-y-16 lg:gap-x-5">
                <div className="col-span-6 grid grid-cols-subgrid sm:col-span-8 sm:col-start-2 sm:flex sm:flex-col sm:justify-center md:col-span-4 md:col-start-1 xl:col-start-2 ">
                    <div className="col-span-5 sm:col-span-full">
                        <Color>
                            <Typography propName="headline" allowList={["S1"]} />
                        </Color>
                    </div>
                    <div className="col-span-full">
                        <Color>
                            <Typography
                                propName="text"
                                size="P1"
                                allowList={["link", "bold", "italic", "small", "sup", "ul", "cl"]}
                            />
                        </Color>
                    </div>
                </div>
                <div className="col-span-6 grid grid-cols-2 gap-[5px] xs:gap-1.5 sm:col-span-10 sm:col-start-2 sm:gap-3 md:col-span-7 md:col-start-6 lg:gap-3.75 xl:col-span-5 xl:col-start-7">
                    {["image1", "image2", "image3", "image4"].map((propName, index) => (
                        <Image
                            maxWidth={323}
                            aspectRatio={AspectRatio["4/5"]}
                            propName={propName}
                            className={classNames(
                                "rounded-xl sm:rounded-3xl lg:rounded-4xl",
                                index === 1
                                    ? "mt-4.5 xs:mt-5 sm:mt-[35px] lg:mt-10.5"
                                    : index === 2
                                    ? "-mt-4.5 xs:-mt-5 sm:-mt-[35px] lg:-mt-10.5"
                                    : ""
                            )}
                            key={index}
                        />
                    ))}
                </div>
            </div>
            <Spacer variant={spacerBottom} />
        </Container>
    )
}

Text4ImagesBlock.schema = {
    name: "Text4ImagesBlock",
    label: "Text 4 Images Block",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/Text4ImagesBlock.png`,
    sideEditProps: [
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
            ],
        },
    ],
    getDefaultProps: (): Text4ImagesBlockProps => ({
        headline: [
            {
                type: "h2",
                children: [
                    {
                        text: "Lorem ipsum",
                        S1: true,
                    },
                ],
            },
        ],
        text: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
                    },
                ],
            },
        ],
        spacerTop: SpacerVariant.XL,
        spacerBottom: SpacerVariant.XL,
    }),
}

export default Text4ImagesBlock
